export const buttonsConstants = {
    tryAgain: "Try Again",
    reload: "Reload Page",
    goHome: "Go to Dashboard",
};
